import Decimal from 'decimal.js';
import _ from 'lodash';

const BEFORE_LAST_THREE_DIGITS_REGEXP = /\B(?=(\d{3})+(?!\d))/g;

export function removeNonAsciiCharacters(str: string): string {
  return str.replace(/[^ -~]+/g, '');
}

export function toSafeString(str: string): string {
  return removeNonAsciiCharacters(_.deburr(str)).trim();
}

export function shortenButRespectWords(str: string, maxLength: number, separator = ' '): string {
  if (str.length <= maxLength) {
    return str;
  }
  return `${str.substring(0, str.lastIndexOf(separator, maxLength))}...`;
}

export function formatPercent(percent: Decimal, toFixed = 2): string {
  const formatted = percent.abs()
                           .toFixed(toFixed)
                           .replace(/\./g, ',');
  return `${formatted}%`;
}

export function formatPercentWithMarks(percent: Decimal, toFixed = 2): string {
  const formatted = formatPercent(percent, toFixed);

  if (percent.greaterThan(0)) {
    return `+${formatted}`;
  }
  if (percent.lessThan(0)) {
    return `-${formatted}`;
  }
  return formatted;
}

export const parseToDecimal = (
  value?: Decimal | number | string
): Decimal | undefined => {
  if (value === undefined) return undefined;
  if (value instanceof Decimal) return value;
  return new Decimal(value);
}

export function formatNumber(value: Decimal,
                             decimalScale = 2,
                             fixedDecimalScale = true,
                             addSpacingBeforeLastThreeIntDigits = true,
                             showMinusSignForNegatives = false): string {
  const abs = value.abs();
  const showMinus = showMinusSignForNegatives && value.isNegative();
  const minusPrefix = showMinus ? '-' : '';

  if (decimalScale === 0) {
    const floorString = minusPrefix + abs.floor().toString();
    if (addSpacingBeforeLastThreeIntDigits) {
      return floorString.replace(BEFORE_LAST_THREE_DIGITS_REGEXP, ' ');
    } else {
      return floorString;
    }
  }

  const decimalFixed = abs.toFixed(decimalScale);

  let integerPart = decimalFixed.replace(/\..*/, '');
  if (addSpacingBeforeLastThreeIntDigits) {
    integerPart = integerPart.replace(BEFORE_LAST_THREE_DIGITS_REGEXP, ' ');
  }

  let decimalPart = decimalFixed.replace(/.*\./, '');
  if (!fixedDecimalScale) {
    decimalPart = decimalPart.replace(/0*$/, '');
  }
  return `${minusPrefix}${integerPart}${decimalPart.length > 0 ? ',' : ''}${decimalPart}`;
}

